import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";
import { DeudaPorPropietario } from "../../../services/analisisFinanzas";
import { useEstadisticasNumericas } from "../../../hooks/estadisticasNumericas";
import { currencyFormat } from "../../../utils/numberUtils";
import EstadisticasBadges from "../../organisms/EstadisticasBadges";
import Pagination from "../../organisms/Pagination";
import { generatePage } from "../../../utils/tableUtils";

interface DeudasPorPropietarioTableProps {
  deudasPorPropietario: DeudaPorPropietario[];
  isLoading: boolean;
  itemsPorPagina: number;
}

function DeudasPorPropietarioTable({
  deudasPorPropietario,
  isLoading,
  itemsPorPagina,
}: DeudasPorPropietarioTableProps) {
  const [activePageNumber, setActivePageNumber] = useState(1);
  const estadisticas = useEstadisticasNumericas(
    deudasPorPropietario,
    (item) => item.totalPendiente
  );

  const paginaActual = useMemo(
    () =>
      generatePage(
        deudasPorPropietario,
        activePageNumber,
        itemsPorPagina
      ) as DeudaPorPropietario[],
    [deudasPorPropietario, activePageNumber, itemsPorPagina]
  );

  return (
    <>
      <EstadisticasBadges
        estadisticas={estadisticas}
        formatearValor={currencyFormat}
      />

      <Table responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Propietario</StyledColHeader>
            <StyledColHeader>Documento</StyledColHeader>
            <StyledColHeader>Total Pendiente</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {paginaActual.map((item) => (
            <tr key={item.idPropietario}>
              <td>{item.propietario}</td>
              <td>{item.documento}</td>
              <td>{currencyFormat(item.totalPendiente)}</td>
            </tr>
          ))}
          {estadisticas && (
            <StyledSummaryRow>
              <td colSpan={2}>Total</td>
              <td>{currencyFormat(estadisticas.total)}</td>
            </StyledSummaryRow>
          )}
          {!isLoading && paginaActual.length === 0 && (
            <tr>
              <td colSpan={3}>
                No hay deudas por propietario para el rango de fechas seleccionado.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        pageSize={itemsPorPagina}
        setActivePageNumber={setActivePageNumber}
        activePageNumber={activePageNumber}
        rows={deudasPorPropietario}
      />
    </>
  );
}

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledSummaryRow = styled("tr")`
  background-color: ${(props) => props.theme.colors.light};
  font-weight: 700;
`;

export default DeudasPorPropietarioTable;
